export default __webpack_public_path__ + "static/media/takePhoto@2x.0aa7af53.png";